// 通用环境
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_ONLINE = !IS_DEV && process.env.BUILD_TYPE === 'online';

// 通用域名
// export const DOMAIN_API = 'http://35.87.238.144/api'; // 海外测试
 export const DOMAIN_API = 'http://35.86.155.186/api'; // 海外正式
// export const DOMAIN_API = 'http://35.87.26.213/api';// 海外正式
// export const DOMAIN_API = 'http://39.106.57.84/api'; // 国内测试
// export const DOMAIN_API = 'http://47.95.14.120/api'; // 国内正式
// export const DOMAIN_API = 'http://39.106.50.132/api'; // 国内正式
// export const DOMAIN_API = 'http://pico-web-2061483434.us-west-2.elb.amazonaws.com'; // 海外正式 合并版
// export const DOMAIN_API = 'http://59.110.170.67'; // 国内正式 合并版
export const DOMAIN_GLOBAL = IS_DEV ? 'localhost' : 'www.picoxr.com';
export const DOMAIN_CN = IS_DEV ? 'localhost' : 'www.pico-interactive.com';

// 通用错误码
export const ERROR_CODE: Record<string, string> = {
  403: '拒绝访问',
  404: '接口地址未找到',
  500: '服务器错误',
  502: '服务器请求超时',
  504: '网关超时',
};

// 通用国家枚举、语言、全称
// export const DEFAULT_COUNTRY = CUSTOM_COUNTRY.toLowerCase() === 'cn' ? 'cn' : 'global';
export const COUNTRY_LIST = ['cn', 'us', 'fr', 'de', 'it', 'jp', 'kr', 'my', 'nl', 'sg', 'es', 'uk', 'th', 'global'];
export const COUNTRY_LAN_ENUM: Record<string, string> = {
  global: 'en',
  my: 'en',
  nl: 'en',
  uk: 'en',
  // my: 'ms-MY',
  // nl: 'sv-SE',
  // uk: 'en-GB',
  th: 'th-TH',
  sg: 'en',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  jp: 'ja-JP',
  kr: 'ko-KR',
  es: 'es-ES',
  cn: 'zh-Hans-CN',
};
export const COUNTRY_LAN_ENUM_OLD: Record<string, string> = {
  global: 'en',
  my: 'en',
  nl: 'en',
  sg: 'en',
  uk: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  jp: 'ja',
  kr: 'ko',
  es: 'es',
  cn: 'zh',
  th: 'th-TH'
};

export const COUNTRY_HREFLANG: Record<string, string> = {
  global: 'x-default',
  // us: 'en-US',
  my: 'en-MY',
  nl: 'en-NL',
  sg: 'en-SG',
  uk: 'en-GB',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  jp: 'ja-JP',
  kr: 'ko-KR',
  es: 'es-ES',
  cn: 'zh-CN',
  th: 'th-TH'
};

export const COUNTRY_FULL_NAME = {
  global: ' Global',
  // us: ' US',
  my: ' Malaysia',
  nl: ' Netherlands',
  sg: ' Singapore',
  uk: ' UK',
  fr: ' France',
  de: ' Germany',
  it: ' Italy',
  jp: ' Japan',
  kr: ' korea',
  es: ' Spain',
  th: ' Thailand',
  cn: '中国',
};

export const COUNTRY_FULL_NAME_ENUM: Record<string, string>[] = [
  { label: 'China - 简体中文', key: 'cn' },
  { label: 'France - Français', key: 'fr' },
  { label: 'Germany - Deutsch', key: 'de' },
  { label: 'Italy - Italiano', key: 'it' },
  { label: 'Japan - 日本語', key: 'jp' },
  { label: 'Korea - 한국어', key: 'kr' },
  { label: 'Singapore - English', key: 'sg' },
  { label: 'Netherlands - English', key: 'nl' },
  { label: 'Malaysia - English', key: 'my' },
  { label: 'UK - English', key: 'uk' },
  // { label: 'United States - English', key: 'us' },
  { label: 'Spain - Español', key: 'es' },
  { label: 'Thailand - ภาษาไทย', key: 'th' },
  { label: 'Global - English', key: 'global' },
];
export const BLOG_MIS_CN = 'https://lf3-cdn-tos.draftstatic.com/obj/ies-hotsoon-draft/game/';
export const BLOG_MIS_UR = 'https://lf16-cc-everphoto.faceulv.com/obj/ies-hotsoon-draft-ec-fr/game/';
export const BLOG_MIS_SG = 'https://sf19-draftcdn-sg.ibytedtos.com/obj/ies-hotsoon-draft-sg/game/';

export const LAN_BLOG_MIS_URL_ENUM: Record<string, string> = {
  en: BLOG_MIS_SG,
  fr: BLOG_MIS_SG,
  de: BLOG_MIS_SG,
  it: BLOG_MIS_SG,
  ja: BLOG_MIS_SG,
  ko: BLOG_MIS_SG,
  es: BLOG_MIS_SG,
  zh: BLOG_MIS_CN,
};

// 设备枚举
export const PICO4_PRO = 'pico4-pro'; // pico4 pro
export const PICO_4 = 'pico4'; // pico4
export const PICO_4E = 'pico4e'; // pico4e
export const PICO_4_PRO = 'pico4-pro'; // pico4e
export const PICO_NEO_3_LINK = 'neo3-link'; // neo3 海外版
export const PICO_NEO_3_LINK_DP = 'neo3-link-dp'; // neo3 海外版
export const PICO_NEO_3_LINK_WIFI = 'neo3-link-wifi'; // neo3 海外版
export const PICO_NEO_3_LINK_ALL = 'neo3-link-all'; // Neo3 Link/Pro/Pro Eye
export const PICO_NEO_3_EYE = 'neo3-pro-eye'; // neo3 TOB版
export const PICO_NEO_3 = 'neo3'; // neo3 国内版
export const PICO_NEO_2 = 'neo2';
export const PICO_LINK_D = 'pico-link';
export const PICO_G2_4KS = 'g2-4ks'; // g2 B端
export const PICO_G2 = 'g2-4k'; // g2 C端
export const PICO_G3 = 'g3'; // g3 B端
export const PICO_DP = 'dp'; // 企业版

// 软件枚举
export const PICO_LINK = 'pico-link';
export const PICO_VR = 'pico-vr';
export const PICO_OS = 'pico-os';
export const PICO_STORE = 'pico-store';
export const PICO_REMOTE_PLAY_ASSISTANG = 'remote-play-assistant';
export const PICO_CAST = 'pico-cast';

// 操作系统枚举
export const WINDOW_10 = 'window-10';
export const WINDOW_7 = 'window-7';
export const MAC_INTEL = 'mac-intel';
export const MAC_APPLE = 'mac-apple';

// 展示信息
export const COUNTRY_SHOW_COOKIE_HEADER = ['global', 'de', 'fr', 'it', 'es', 'uk', 'us'];
export const isShowCookieSet = (ctry: string): boolean => COUNTRY_SHOW_COOKIE_HEADER.includes(ctry);

export const concatEnum = {
  global: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  fr: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  de: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  it: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  es: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  jp: {
    email: 'support.jp@pico-xr.com',
    phone: '81363731050 (平日10：00-19：00対応)',
    warrantyPhone: '03-5657-0964'
  },
  kr: {
    email: 'support.kr@pico-xr.com',
    phone: '8215336310'
  },
  my: {
    email: 'support.my@pico-xr.com',
    phone: '601117040071'
  },
  sg: {
    email: 'support.sg@pico-xr.com',
    phone: '601117040071'
  },
  uk: {
    email: 'support.eur@pico-xr.com',
    phone: '442080599866'
  },
  nl: {
    email: 'support.eur@pico-xr.com',
    phone: '493058916141'
  },
  th: {
    email: 'support.th@pico-xr.com',
    phone: '6625660782'
  }
}

